const INLINE_EDITORS = {};
export function addInlineEditor(moduleName) {
  INLINE_EDITORS[moduleName] = INLINE_EDITORS[moduleName] ? INLINE_EDITORS[moduleName] + 1 : 1;
}
export function removeInlineEditor(moduleName) {
  INLINE_EDITORS[moduleName] = INLINE_EDITORS[moduleName] ? INLINE_EDITORS[moduleName] - 1 : 0;
}
export function getHasInlineEditor(moduleName) {
  return Boolean(INLINE_EDITORS[moduleName] && INLINE_EDITORS[moduleName] > 0);
}
const MODULE_INSERTION_DATA_ATTR = 'data-hs-module-insertion';
export const moduleInsertionNopeZoneSelector = `[${MODULE_INSERTION_DATA_ATTR}="true"]`;
export function addModuleInsertionDataAttribute(node) {
  node.setAttribute(MODULE_INSERTION_DATA_ATTR, 'true');
}